import modal from "modal";
import Bacon from "Bacon";
import $ from "jquery";
import c from "common";
import select from "custom-select";

$(document.body).asEventStream('click', '.prompt-select-cancel').doAction(c.stopEvent).onValue(modal.close);

export default {
  open: function (options) {
    options.modalClass = "prompt-select-modal";
    return modal.open("prompt-select", Bacon.combineTemplate(options)).doAction(modal.center).flatMap(function () {
      var $select = $('.prompt-select-modal select');
      var selection = select.init($select).toProperty($select.val());
      return selection.sampledBy($('.prompt-select-confirm').asEventStream('click').doAction(c.stopEvent).map(true)
        .merge(modal.closeStream.map(false))
        .take(1).doAction(modal.close).filter(c.isTrue));
    });
  }
};



// WEBPACK FOOTER //
// ./web/js/prompt-select.js